import _ from 'lodash';

import feeTiers from '../../api/feeTiers';
import * as types from '../mutation-types';

const state = {
  feeTiers: []
};

const getters = {
  FeeTiers: state => state.feeTiers
};

const actions = {
  getFeeTiers({ commit }, parentId) {
    feeTiers.getFeeTiers(parentId).then(response => {
      commit(types.SET_FEE_TIERS, response.data);
    });
  },
  updateFeeTier({ commit }, { id, updates }) {
    feeTiers
      .updateFeeTier(id, updates)
      .then(response => {
        commit(types.SET_UPDATE_FEE_TIER, response.data);
      })
      .catch(error => console.log(error));
  },
  addFeeTier({ dispatch }, feeTier) {
    return new Promise((resolve, reject) => {
      feeTiers
        .addFeeTier(feeTier)
        .then(() => {
          dispatch('selectFunder', { id: feeTier.parent_id });
          resolve(true);
        })
        .catch(error => reject(error));
    });
  },
  deleteFeeTier({ dispatch }, feeTier) {
    return new Promise((resolve, reject) => {
      feeTiers
        .deleteFeeTier(feeTier.id)
        .then(() => {
          dispatch('selectFunder', { id: feeTier.parent_id });
          resolve(true);
        })
        .catch(error => reject(error));
    });
  }
};

const mutations = {
  [types.SET_FEE_TIERS](state, response) {
    state.feeTiers = response;
  },
  [types.SET_UPDATE_FEE_TIER](state, response) {
    const record = _.find(state.feeTiers, feeTier => feeTier.id === response.id);
    _.merge(record, response);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
